/**
 * RSC — Retail Signing Center routes.
 *
 *   /rsc                              → Active signing sessions list
 *   /rsc/session/:sessionId           → session detail (signer grid + downloads)
 *   /rsc/session/:sessionId/correct   → correction drawer (pre- vs post-submit)
 *   /rsc/session/:sessionId/wet       → wet-sign QR reassembly completion
 *   /rsc/session/:sessionId/embed     → embedded SignNow iframe
 */
import { Routes, Route } from 'react-router';
import { SplatRedirect } from '@/components/common/SplatRedirect';
import RscDashboard from './index';
import { SessionDetail } from './SessionDetail';
import { CorrectionDrawer } from './CorrectionDrawer';
import { WetSignCompletion } from './WetSignCompletion';
import { EmbeddedSign } from './EmbeddedSign';

export function RscRoutes(): JSX.Element {
  return (
    <Routes>
      <Route index element={<RscDashboard />} />
      <Route path="session/:sessionId" element={<SessionDetail />} />
      <Route path="session/:sessionId/correct" element={<CorrectionDrawer />} />
      <Route path="session/:sessionId/wet" element={<WetSignCompletion />} />
      <Route path="session/:sessionId/embed" element={<EmbeddedSign />} />
      <Route path="*" element={<SplatRedirect />} />
    </Routes>
  );
}
